<template>
  <div class="jl-footer-wrap">
    <div class="jl-footer-gotop" @click="goTop(0)">
      <img src="../assets/img/zkj-top_03.png" alt />
      <p class="text1">返回顶部</p>
    </div>
    <div class="jl-footer-1">
      <div class="jl-footer-container">
        <div class="jl-footer-nav-box">
          <ul class="jl-footer-navlist">
            <li>
              <router-link :to="{ name: 'home' }">荔虹首页</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'auction' }">拍卖中心</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'shop' }">商品中心</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'knowledge' }">锦鲤知识</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'news' }">新闻资讯</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'about' }">关于公司</router-link>
            </li>
            <li v-if="userInfo.userId">
              <router-link :to="{ name: 'account' }">个人中心</router-link>
            </li>
          </ul>
        </div>
        <div class="jl-footer-tel-box">
          <p>
            <span class="span-1">电话：</span>
            <span class="span-2 alt">021-37016358</span>
          </p>
          <p>
            <span class="span-1">邮箱：</span>
            <span class="span-2">lihongjinliyuan@163.com</span>
          </p>
        </div>
        <div class="jl-footer-address">
          <p class="text1">
            地址：上海白鹤镇塘湾村沈家村队108号（赵重公路和纪鹤公路口）
          </p>
        </div>
      </div>
    </div>
    <div class="jl-footer-2">
      <div class="jl-footer-container">
        <p class="text1">
          备案：沪ICP备12014369号-1 沪公网安备 31011802001543号
        </p>
        <img src="../assets/img/footer_img.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    goTop(targetPageY) {
      var timer = setInterval(function() {
        var currentY =
          document.documentElement.scrollTop || document.body.scrollTop; //当前及滑动中任意时刻位置
        var distance =
          targetPageY > currentY
            ? targetPageY - currentY
            : currentY - targetPageY; //剩余距离
        var speed = Math.ceil(distance / 10); //每时刻速度
        if (currentY == targetPageY) {
          clearInterval(timer);
        } else {
          window.scrollTo(
            0,
            targetPageY > currentY ? currentY + speed : currentY - speed
          );
        }
      }, 10);
    }
  }
};
</script>

<style lang="scss" scoped>
.clearfix::after {
  content: '';
  clear: both;
}
.jl-footer-wrap {
  position: relative;
  background: #1f1f1f;
  .jl-footer-container {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  .jl-footer-nav-box {
    padding: 120px 0 90px 0;
    text-align: center;
  }
  .jl-footer-navlist {
    display: inline-block;
    li {
      display: inline-block;
      vertical-align: middle;
      > a {
        position: relative;
        display: inline-block;
        padding: 0 29px;
        font-size: 16px;
        color: #fff;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 1px;
          height: 100%;
          background: #313131;
        }
      }
      &:first-child > a::before {
        width: 0;
      }
    }
  }
  .jl-footer-tel-box {
    width: 374px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 35px;
    p {
      color: #fff;
      text-align: left;
    }
    .span-1 {
      font-size: 24px;
    }
    .span-2 {
      font-size: 24px;
      &.alt {
        font-size: 42px;
      }
    }
  }
  .jl-footer-address {
    font-size: 18px;
    color: #fff;
    text-align: center;
    margin-bottom: 56px;
  }
  .jl-footer-2 {
    padding-top: 30px;
    border-top: 1px solid #323232;
    text-align: center;
    .text1 {
      font-size: 16px;
      color: #999;
      margin-bottom: 42px;
    }
  }
  .jl-footer-gotop {
    position: absolute;
    left: 50%;
    top: -41px;
    transform: translateX(-50%);
    cursor: pointer;
    .text1 {
      font-size: 16px;
      color: #fff;
      text-align: center;
    }
  }
}

@media screen and (min-width: 1200px) {
  .jl-footer-wrap .jl-footer-navlist li > a:hover {
    color: #e50011;
  }
}
</style>
